module.exports = __webpack_public_path__ + "media/images/plans/schedule_2-07f3c34caa21e88cd3ea893a88827c27.jpg";